interface IChangePassword {
  modifiedDate: Date;
  id: string;
  modifiedBy: string;
  oldPassword: string;
  password: string;
  hashedPassword: string;
  salt: string;
}

export class ChangePasswordModel implements IChangePassword {
  modifiedDate: Date = new Date();
  id: string = '';
  modifiedBy: string = '';
  oldPassword: string = '';
  password: string = '';
  hashedPassword: string = '';
  salt: string = '';

  constructor(props: Partial<IChangePassword> = {}) {
    Object.assign(this, props);
  }
}
